module.exports = __webpack_public_path__ + "img/e_2_10_g.ada06a04.png";